import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@shared/shared.module'
import { PasswordStrengthComponent } from '@shared/components/password-strength/password-strength.component'

import { AuthRoutingModule } from './auth-routing.module'

import { ResetPasswordComponent } from './reset-password/reset-password.component'
import { SetPasswordComponent } from './set-password/set-password.component'
import { OneTimePasswordComponent } from './one-time-password/one-time-password.component'
import { VerifyPhoneNumberComponent } from './verify-phone-number/verify-phone-number.component'
import { ExpiredLinkComponent } from './expired-link/expired-link.component'
import { CheckMobilePhoneComponent } from './check-mobile-phone/check-mobile-phone.component'
import { LoginComponent } from './login/login.component'
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component'

@NgModule({
  declarations: [
    ResetPasswordComponent,
    SetPasswordComponent,
    OneTimePasswordComponent,
    VerifyPhoneNumberComponent,
    ExpiredLinkComponent,
    CheckMobilePhoneComponent,
    LoginComponent,
    TermsOfUseComponent,
  ],
  imports: [CommonModule, PasswordStrengthComponent, AuthRoutingModule, SharedModule],
})
export class AuthModule {}
